(ns app.front.view.permit.sign-off
  (:require [app.domain.verdict.model :as verdict-model]
            [app.front.file.upload :as upload]
            [app.front.process :as process]
            [app.front.view.sign-off :as sign-off]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [reagent.ratom]))

(rf/reg-event-fx ::sign-off-completed
  (fn [{:keys [db]} [_ workspace-id]]
    {:set-location [:view/workspace-application
                    {:workspace-id workspace-id}
                    "#section--application-permits"]
     :db           (dissoc db ::signing-off)}))

(rf/reg-event-db ::start-sign-off
  (fn [db _]
    (assoc db ::signing-off true)))

(rf/reg-event-db ::stop-sign-off
  (fn [db _]
    (dissoc db ::signing-off)))

(rf/reg-sub ::signing-off?
  :-> ::signing-off)

(defn sign-off-block [{:keys [tr verdict application]}]
  (let [application-id      (:db/id application)
        ws-id               (-> application :entity/parent :workspace/id)
        verdict-id          (:db/id verdict)
        sign-off-permitted? (<sub [::process/app-signal-permitted? [:process.signal/permit-sign-off
                                                                    {:id verdict-id}]])
        upload-permitted?   (<sub [::process/app-signal-permitted? [:process.signal/upload-permit-sign-off
                                                                    {:id verdict-id}]])]
    (if (<sub [::signing-off?])
      (cc/inline-loading {:description (tr [:sign-off/processing])})
      [:div
       (when upload-permitted?
         [:div
          (cc/link {:href (str "/api/command/verdict/download-draft?id=" verdict-id)}
                   (tr [:verdict/download-draft]))])
       [:div.flex.flex-row.mt-4
        (cc/button {:kind             :primary
                    :class-name       "self-start lg:self-end"
                    :on-click         (fn [_]
                                        (>evt [::start-sign-off])
                                        (>evt [:app.front.process/signal
                                               application-id
                                               [:process.signal/permit-sign-off {:id verdict-id}]
                                               {:on-success [::sign-off-completed ws-id]
                                                :on-done    [::stop-sign-off]
                                                :on-error   [::stop-sign-off]}]))
                    :data-cy          "sign-off-signature"
                    :icon             i/undersign
                    :disabled         (not sign-off-permitted?)
                    :icon-description (tr [:signature/sign-off])}
                   (tr [:signature/sign-off]))
        (when upload-permitted?
          [upload/upload-button
           "upload-signed-permit"
           {:attach-file-fn (fn [file-id filename content-type md5]
                              (>evt [::start-sign-off])
                              (>evt [:app.front.process/signal
                                     application-id
                                     [:process.signal/upload-permit-sign-off
                                      {:id                verdict-id
                                       :file-id           file-id
                                       :file/filename     filename
                                       :file/content-type content-type
                                       :file/md5          md5}]
                                     {:on-success [::sign-off-completed ws-id]
                                      :on-done    [::stop-sign-off]
                                      :on-error   [::stop-sign-off]}]))
            :accept-types   [".pdf" "application/pdf"]
            :multiple       false
            :class          "ml-2"
            :label-text     (tr [:signature/upload-pdf])}])
        (when (not sign-off-permitted?)
          [:div.flex.items-center.ml-4
           (cc/icon {:icon        i/circle-attention
                     :description (tr [:warning/warning])
                     :fill        "#616161"
                     :class-name  "mr-2 w-6 flex-shrink-0"})
           [:div.leading-tight.flex-shrink
            (tr [:sign-off/sign-off-has-to-be-done-by-one-of-the-roles]
                (->> verdict-model/permit-sign-off-roles
                     (map #(tr [%]))
                     (into [])))]])]])))

(defn sign-off-section [{:keys [tr verdict application]}]
  (when (:verdict/sign-off-required? verdict)
    [:div
     (if-let [signer (:verdict/sign-off-by verdict)]
       [:div.flex.flex-row.mt-4 [sign-off/signature (util/mmap {:created (:verdict/sign-off-date verdict)} signer tr)]]
       (when (->> application
                  :process/state
                  (contains? #{:process.state/permit-fee-payment
                               :process.state/permit-sign-off
                               :process.state/re-issue-permit-sign-off}))
         [sign-off-block (util/mmap {:application (-> verdict :entity/parent)} tr verdict)]))]))
